const StarIcon = () => {
  return (
    <svg
      width="19"
      height="18"
      viewBox="0 0 19 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M9.20711 14.3074L13.3571 16.8174C14.1171 17.2774 15.0471 16.5974 14.8471 15.7374L13.7471 11.0174L17.4171 7.83736C18.0871 7.25736 17.7271 6.15736 16.8471 6.08736L12.0171 5.67736L10.1271 1.21736C9.78711 0.407363 8.62711 0.407363 8.28711 1.21736L6.39711 5.66736L1.5671 6.07736C0.687104 6.14736 0.327104 7.24736 0.997104 7.82736L4.66711 11.0074L3.56711 15.7274C3.36711 16.5874 4.29711 17.2674 5.05711 16.8074L9.20711 14.3074Z"
        fill="#1B1B1B"
      />
    </svg>
  );
};
export {
    StarIcon
}
